module.exports = __webpack_public_path__ + "img/type-style5.55507412.png";